// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-action-pop-ballon {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  margin: auto !important;
  bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/BalloonModal/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,uBAAA;EACA,SAAA;AACF","sourcesContent":[".modal-action-pop-ballon {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  margin: auto !important;\n  bottom: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
